module.exports = __webpack_public_path__ + "img/icon_wen.84179018.png";